module.exports = import("https://unpkg.com/swiper@11.0.7/swiper-bundle.js");;